import { useContext, useState, useEffect } from 'react'
import AdminSideBar from '../../components/adminSideBar/AdminSideBar';
import './createEnvoie.css';
import { communes, NatureEnvois, typeDeliveries, typeEnvois, typeRamassages, wilayas } from '../../data';
import FormRadio from '../../components/formRadio/FormRadio';
import FormInput from '../../components/formInput/FormInput';
import { AuthContext } from '../../context/authContext/AuthContext';
import DropDownComponent from '../../components/dropDownComponent/DropDownComponent';
import { AgenceContext } from '../../context/agenceContext/AgenceContext';
import { getAgencesByWilaya } from '../../context/agenceContext/apiCalls';
import { addEnvoie, simulateGetCost } from '../../context/envoieContext/apiCalls';
import { EnvoieContext } from '../../context/envoieContext/EnvoieContext';
import { useNavigate } from 'react-router-dom';

function CreateEnvoie() {
    const [typeEnvoie, setTypeEnvoie] = useState(typeEnvois[0]);
    const [typeDelivery, setTypeDelivery] = useState(typeDeliveries[0]);
    const [typeRamassage, setTypeRamassage] = useState(typeRamassages[0]);
    const { user } = useContext(AuthContext);
    const [errorBox, setErrorBox] = useState("");
    const { dispatch: dispatchAgence, agencesByWilaya } = useContext(AgenceContext);
    const { dispatch, envoie, isFetchingAdd, errorAdd, isFetchingSimulate, cost } = useContext(EnvoieContext);
    const navigate = useNavigate();

    /*  Sender  */
    const [nomSender, setNomSender] = useState(() => {
        if (user.entreprise) {
            return user.entreprise.nom || "";
        } else {
            return user.nom || "";
        }
    });
    const [emailSender, setEmailSender] = useState(() => {
        if (user.entreprise) {
            return user.entreprise.email || "";
        } else {
            return user.email || "";
        }
    });
    const [tel1Sender, setTel1Sender] = useState(() => {
        if (user.entreprise) {
            return user.entreprise.tel1 || "";
        } else {
            return user.tel1 || "";
        }
    });
    const [tel2Sender, setTel2Sender] = useState(() => {
        if (user.entreprise) {
            return user.entreprise.tel2 || "";
        } else {
            return user.tel2 || "";
        }
    });
    const [wilayaSender, setWilayaSender] = useState(() => {
        if (user.entreprise) {
            return wilayas.filter(item => item.id === user.entreprise.wilaya)[0] || wilayas[0];
        } else {
            return wilayas.filter(item => item.id === user.wilaya)[0] || wilayas[0];
        }
    });
    const [agenceSender, setAgenceSender] = useState({ nom: "Choisir Agence", id: 0 });
    const [addressSender, setAddressSender] = useState(() => {
        if (user.entreprise) {
            return user.entreprise.address
        } else {
            return "";
        }
    });


    /*  Receiver  */
    const [nomReceiver, setNomReceiver] = useState("");
    const [prenomReceiver, setPrenomReceiver] = useState("");
    const [emailReceiver, setEmailReceiver] = useState("");
    const [tel1Receiver, setTel1Receiver] = useState("");
    const [tel2Receiver, setTel2Receiver] = useState("");
    const [wilayaReceiver, setWilayaReceiver] = useState(wilayas[0]);
    const [communeReceiver, setCommuneReceiver] = useState(communes[0][0]);
    const [addressReceiver, setAddressReceiver] = useState("");
    const [agenceReceiver, setAgenceReceiver] = useState({ nom: "Choisir Agence", id: 0, })

    /*  Details  */
    const [description, setDescription] = useState("");
    const [number, setNumber] = useState("");
    const [montant, setMontant] = useState("");
    const [nature, setNature] = useState(NatureEnvois[0]);
    const [weight, setWeight] = useState("");
    const [result, setResult] = useState("");

    useEffect(() => {
        getAgencesByWilaya(dispatchAgence);
    }, [])

    useEffect(() => {
        setAgenceSender({ nom: "Choisir Agence", id: 0, });
    }, [wilayaSender])

    useEffect(() => {
        setCommuneReceiver(communes[wilayaReceiver.id][0]);
        setAgenceReceiver({ nom: "Choisir Agence", id: 0, });
    }, [wilayaReceiver])
    
    useEffect(() => {
        setErrorBox('');
        setResult(`${cost}`);
    }, [cost])

    useEffect(() => {
        window.scroll({ top: 0, left: 0, behavior: 'smooth' })
    }, [errorBox])

    useEffect(() => {
        if (errorAdd != false) {
            setErrorBox(errorAdd);
        }
    }, [errorAdd])

    useEffect(() => {
        if (Object.keys(envoie).length !== 0) {
            setErrorBox('');
            navigate(`/envois`);
        }
    }, [envoie])

    useEffect(() => {
        if (wilayaSender.id === 0 || wilayaReceiver.id === 0 || weight.trim() == "" || isNaN(weight)) {
            setResult("");
        } else {
            simulateGetCost(dispatch, wilayaSender.id, wilayaReceiver.id, weight, typeEnvoie.id, typeDelivery.id, typeRamassage.id, user.entreprise ? user.entreprise.id : null);
        }
    }, [wilayaSender, wilayaReceiver, weight, typeEnvoie, typeDelivery, typeRamassage])


    /*  Functions  */
    const handleAddEnvoie = (e) => {
        e.preventDefault();
        if (nomSender.trim() == "") {
            setErrorBox(`Vous devez compléter le Nom d'expéditeur`);
            return;
        }
        if (tel1Sender.trim() == "") {
            setErrorBox(`Vous devez compléter le Tel 1 d'expéditeur`);
            return;
        }
        if (wilayaSender.id === 0) {
            setErrorBox(`Vous devez compléter la Wilaya d'expéditeur`);
            return;
        }

        if (typeRamassage.id === 2) {
            if (agenceSender.id === 0) {
                setErrorBox(`Vous devez compléter l'Agence de Départ`);
                return;
            }
        } else {
            if (addressSender.trim() == "") {
                setErrorBox(`Vous devez compléter l'Adresse d'expéditeur`);
                return;
            }
        }

        if (nomReceiver.trim() == "") {
            setErrorBox(`Vous devez compléter le Nom de destinataire`);
            return;
        }
        if (tel1Receiver.trim() == "") {
            setErrorBox(`Vous devez compléter le Tel 1 de destinataire`);
            return;
        }
        if (wilayaReceiver.id === 0) {
            setErrorBox(`Vous devez compléter la wilaya de destinataire`);
            return;
        }
        if (typeDelivery.id === 2) {
            if (agenceReceiver.id === 0) {
                setErrorBox(`Vous devez compléter l'Agence d'Arrivé`);
                return;
            }
        } else {
            if (communeReceiver.id === 0) {
                setErrorBox(`Vous devez compléter la commune de destinataire`);
                return;
            }
            if (addressReceiver.trim() == "") {
                setErrorBox(`Vous devez compléter l'Adresse de destinataire`);
                return;
            }
        }
        if (description.trim() == "") {
            setErrorBox(`Vous devez compléter la Description`);
            return;
        }
        if (montant.trim() == "") {
            setErrorBox(`Vous devez compléter le Montant`);
            return;
        }
        if (isNaN(montant)) {
            setErrorBox(`Montant doit etre un nombre`);
            return;
        }
        if (weight.trim() == "") {
            setErrorBox(`Vous devez compléter le Poids en KG`);
            return;
        }
        if (isNaN(weight)) {
            setErrorBox(`Le poids doit etre un nombre`);
            return;
        }
        addEnvoie(
            dispatch, typeEnvoie.id, typeDelivery.id, typeRamassage.id, wilayaSender.id, agenceSender.id, addressSender,nomSender, emailSender, tel1Sender, tel2Sender, 
            nomReceiver, prenomReceiver, emailReceiver, tel1Receiver, tel2Receiver, wilayaReceiver.id,communeReceiver.id, addressReceiver, agenceReceiver.id, 
            description, number, montant, nature.id, weight);
    }

    return (
        <div className='container-global'>
            <AdminSideBar activeTab="envoie" />
            <div className='center'>
                <div className="title">
                    <span className="material-symbols-rounded">shoppingmode</span>
                    <span>Créer Envoie :</span>
                </div>

                {errorBox !== "" && (<div style={{ marginBottom: "25px" }} className='box-error'>{errorBox}</div>)}

                <div className="content envoie">
                    <div className="box">
                        <div className="box-title">Type d'Envoie :</div>
                        <div className="box-content">
                            <FormRadio data={typeEnvois} itemChoisir={typeEnvoie} setItemChoisir={setTypeEnvoie} name='type-envoie' />
                        </div>
                    </div>
                    <div className='big-box'>
                        {/* Sender */}
                        <div className="box">
                            <div className="box-title">Expéditeur :</div>
                            <div className="box-content">
                                <div className='side-to-side-envoie'>
                                    <FormInput label='Nom *' itemInput={nomSender} setItemInput={setNomSender} auth />
                                </div>
                                <FormInput label='Email' itemInput={emailSender} setItemInput={setEmailSender} auth />
                                <div className='side-to-side-envoie' >
                                    <FormInput label='Tel 1 *' itemInput={tel1Sender} setItemInput={setTel1Sender} auth istype='number' />
                                    <FormInput label='Tel 2' itemInput={tel2Sender} setItemInput={setTel2Sender} auth istype='number'/>
                                </div>
                                <DropDownComponent data={wilayas} itemChoisir={wilayaSender} setItemChoisir={setWilayaSender} />
                                <FormRadio data={typeRamassages} itemChoisir={typeRamassage} setItemChoisir={setTypeRamassage} name='type-ramassage' />
                                {
                                    typeRamassage.id === 2 ? (
                                        <DropDownComponent data={[{ nom: "Choisir Agence", id: 0, },...agencesByWilaya.filter(item=>item.wilaya===wilayaSender.id)]} itemChoisir={agenceSender} setItemChoisir={setAgenceSender} />
                                    ) : (
                                        <FormInput label='Adresse départ *' itemInput={addressSender} setItemInput={setAddressSender} auth />
                                    )
                                }
                            </div>
                        </div>

                        {/* Receiver */}
                        <div className="box">
                            <div className="box-title">Destinataire :</div>
                            <div className="box-content">
                                <div className='side-to-side-envoie'>
                                    <FormInput label='Nom *' itemInput={nomReceiver} setItemInput={setNomReceiver} auth />
                                </div>
                                <FormInput label='Email' itemInput={emailReceiver} setItemInput={setEmailReceiver} auth />
                                <div className='side-to-side-envoie'>
                                    <FormInput label='Tel 1 *' itemInput={tel1Receiver} setItemInput={setTel1Receiver} auth istype='number' />
                                    <FormInput label='Tel 2' itemInput={tel2Receiver} setItemInput={setTel2Receiver} auth istype='number' />
                                </div>
                                <DropDownComponent data={wilayas} itemChoisir={wilayaReceiver} setItemChoisir={setWilayaReceiver} />
                                <FormRadio data={typeDeliveries} itemChoisir={typeDelivery} setItemChoisir={setTypeDelivery} name='type-delivery' />
                                {
                                    typeDelivery.id === 1 ? (
                                        <>
                                            <DropDownComponent data={communes[wilayaReceiver.id]} itemChoisir={communeReceiver} setItemChoisir={setCommuneReceiver} />
                                            <FormInput label='Adresse *' itemInput={addressReceiver} setItemInput={setAddressReceiver} auth />
                                        </>
                                    ) : (
                                        <DropDownComponent data={[{ nom: "Choisir Agence", id: 0, },...agencesByWilaya.filter(item=>item.wilaya===wilayaReceiver.id)]} itemChoisir={agenceReceiver} setItemChoisir={setAgenceReceiver} />
                                    )
                                }
                            </div>
                        </div>
                    </div>

                    {/* Details */}
                    <div className="box">
                        <div className="box-title">Détails :</div>
                        <div className="box-content">
                            <FormInput label='Description *' itemInput={description} setItemInput={setDescription} auth />
                            <div className='side-to-side-envoie'>
                                <FormInput label='Numero' itemInput={number} setItemInput={setNumber} auth />
                                <FormInput label='Montant *' itemInput={montant} setItemInput={setMontant} auth />
                            </div>
                            <FormRadio data={NatureEnvois} itemChoisir={nature} setItemChoisir={setNature} name='nature-envoie' />
                            <div className='side-to-side-envoie'>
                                <FormInput label='Poids en KG *' itemInput={weight} setItemInput={setWeight} auth />
                                {
                                    result !== "" && (
                                        ((typeEnvoie.id === 1 || typeEnvoie.id === 2) && typeRamassage.id === 1)
                                            ? (<FormInput label='Cout en Dinars' itemInput={`${result} + Cout Ramassage`} setItemInput={setResult} auth inactive />)
                                            : (<FormInput label='Cout en Dinars' itemInput={result} setItemInput={setResult} auth inactive />)
                                    )
                                }
                            </div>
                        </div>
                    </div>
                    <div className='button'>
                        <span className='add' onClick={handleAddEnvoie} style={isFetchingAdd ? { cursor: 'not-allowed', pointerEvents: 'none' } : {}}>
                            {isFetchingAdd ? "Ajouter Envoie ..." : "Ajouter Envoie"}
                        </span>
                        <span className='active' onClick={() => navigate('/envois/1')}>Retour</span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CreateEnvoie
